import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ProductCard from '../common/ProductCard';

const FeaturedProducts = ({ title, subtitle, products, viewAllLink, bgColor = '#fff' }) => {
  const navigate = useNavigate();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <Box sx={{ py: 6, bgcolor: bgColor }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4,
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Box>
            {subtitle && (
              <Typography
                variant="overline"
                sx={{ color: '#876513', fontWeight: 600, letterSpacing: 2 }}
              >
                {subtitle}
              </Typography>
            )}
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, color: '#3E2723' }}
            >
              {title}
            </Typography>
          </Box>
          {viewAllLink && (
            <Button
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate(viewAllLink)}
              sx={{
                color: '#876513',
                fontWeight: 600,
                '&:hover': { bgcolor: 'rgba(139,69,19,0.05)' },
              }}
            >
              View All
            </Button>
          )}
        </Box>

        <Grid container spacing={3}>
          {products.slice(0, 4).map((product) => (
            <Grid
              item
              xs={6}
              sm={6}
              md={3}
              key={product._id}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturedProducts;
